//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Chart from 'chart.js';
import {mapGetters, mapMutations} from "vuex";
import TimeSeries from "@/components/metrics/TimeSeries";
import ImpactCard from "@/components/cards/ImpactCard";

export default {
  name: "OverallMetrics",
  components: {ImpactCard, TimeSeries},
  data: () => ({
    hideEnrichment: false,
    hidePerformance: false,
    lifeCycleTotal: 0
  }),

  computed: {
    ...mapGetters(["metrics"]),
    total: function () {
      return this.metrics.total ? this.metrics.total.map(item => item.doc_count).reduce((a, b) => a + b, 0) : 0;
    },

    filled: function () {
      return this.metrics.filled ? this.metrics.filled.map(item => item.doc_count).reduce((a, b) => a + b, 0) : 0;
    },

    corrected: function () {
      return this.metrics.corrected ? this.metrics.corrected.map(item => item.doc_count).reduce((a, b) => a + b, 0) : 0;
    }
  },

  mounted() {
    Chart.defaults.global.legend.labels.usePointStyle = true;
    Chart.defaults.global.legend.align = 'start';
    this.loadModelMetrics();
  },

  methods: {
    ...mapMutations({
      displayError: 'displayError',
    }),

    loadModelMetrics() {
      window.setTimeout(() => {
        this.createChartPerformance();
        this.createChartEnrichments();
        this.createChartModels();
      }, 100);
    },

    fetchEnrichments() {
      this.$refs.enrichments_pp.params.queryParams = " ";
      return this.$refs.enrichments_pp.fetch().then(response => {
        let enrichments = {};
        response.aggregations.filled_agg.buckets.forEach(bucket => {
          enrichments[bucket.key] = {};
          enrichments[bucket.key].filled = bucket.docCount;
        });
        response.aggregations.corrected_agg.buckets.forEach(bucket => {
          if (!enrichments.hasOwnProperty(bucket.key)) {
            enrichments[bucket.key] = {};
          }
          enrichments[bucket.key].corrected = bucket.docCount;
        });
        return enrichments;
      });
    },

    createChartEnrichments() {
      this.fetchEnrichments().then((enrichments) => {
        this.hideEnrichment = false;
        const labels = Object.keys(enrichments);
        const filledCounts = labels.map((label) => enrichments[`${label}`].filled);
        const correctedCounts = labels.map((label) => enrichments[`${label}`].corrected);
        if (labels.length === 0 || (filledCounts.length === 0 && correctedCounts.length === 0)) {
          this.hideEnrichment = true;
        } else {
          this.drawEnrichmentChart(labels, filledCounts, correctedCounts);
        }
      }).catch(e => {
        console.error(e);
        this.hideEnrichment = true;
      });
    },

    drawEnrichmentChart(labels, filledCounts, correctedCounts) {
      const data = {
        labels: labels,
        datasets: [{
          label: 'Auto-Filled',
          backgroundColor: this._chartColor('Auto-Filled', 0.6),
          borderColor: this._chartColor('Auto-Filled'),
          borderWidth: 2,
          data: filledCounts,
          pointBorderColor: this._chartColor('Auto-Filled'),
          pointBackgroundColor: 'white',
        }, {
          label: 'Auto-Corrected',
          backgroundColor: this._chartColor('Auto-Corrected', 0.6),
          borderColor: this._chartColor('Auto-Corrected'),
          borderWidth: 2,
          data: correctedCounts,
          pointBorderColor: this._chartColor('Auto-Corrected'),
          pointBackgroundColor: 'white',
        }],
      };
      new Chart(this.$refs.chartEnrichments, {
        maintainAspectRatio: true,
        type: 'radar',
        data: data,
        options: {
          responsive: true,
          maintainAspectRatio: true,
          hover: {
            mode: 'index'
          },
          legend: {
            display: true,
            position: 'bottom',
          },
        }
      });
    },

    fetchFilled() {
      this.$refs.filled_pp.params.queryParams = 'AND enrichment:filled/* IS NOT NULL';
      return this.$refs.filled_pp.fetch()
          .then(result => {
            return result.resultsCount;
          });
    },

    fetchCorrected() {

      this.$refs.corrected_pp.params.queryParams = 'AND enrichment:corrected/* IS NOT NULL';
      return this.$refs.corrected_pp.fetch()
          .then(result => {
            return result.resultsCount;
          });
    },

    fetchOthers() {
      this.$refs.others_pp.params.queryParams = 'AND enrichment:corrected/* IS NULL AND enrichment:filled/* IS NULL';
      return this.$refs.others_pp.fetch()
          .then(result => {
            return result.resultsCount;
          });
    },

    createChartPerformance() {
      Promise.all([this.fetchFilled(), this.fetchCorrected(), this.fetchOthers()])
          .then((results) => {
            this.hidePerformance = false;
            this.drawPerformanceChart(results[0], results[1], results[2]);
          })
          .catch(e => {
            console.error(e);
            this.hidePerformance = true;
          });
    },

    drawPerformanceChart(filled, corrected, others) {
      const data = {
        labels: [this.$t('insight.metrics.overview.enriched.documents')],
        datasets: [{
          data: [filled],
          label: 'Auto-Filled',
          backgroundColor: [this._chartColor('Auto-Filled')],
          maxBarThickness: 16
        }, {
          data: [corrected],
          label: 'Auto-Corrected',
          backgroundColor: [this._chartColor('Auto-Corrected')],
          maxBarThickness: 16
        }, {
          data: [others],
          label: 'Other',
          backgroundColor: [this._chartColor('Other')],
          maxBarThickness: 16
        }],
      };

      new Chart(this.$refs.chartPerformance, {
        maintainAspectRatio: true,
        type: 'horizontalBar',
        data: data,
        options: {
          responsive: true,
          maintainAspectRatio: true,
          hover: {
            mode: 'index'
          },
          legend: {
            display: true,
            position: 'bottom'
          },
          scales: {
            xAxes: [{
              ticks: {
                beginAtZero: true,
              }
            }],
            yAxes: [{
              display: false
            }]
          }
        }
      });
    },

    fetchModels() {
      this.$refs.models_pp.params.queryParams = '("false", "true")';
      return this.$refs.models_pp.fetch().then(response => {
        let lifeCyles = {};
        response.aggregations.system_currentLifeCycleState_agg.buckets.forEach(bucket => {
          lifeCyles[bucket.key] = {};
          lifeCyles[bucket.key].counts = bucket.docCount;
        });
        return lifeCyles;
      });
    },

    createChartModels() {
      this.fetchModels().then((lifeCycles) => {
        const lifeCycleLabels = Object.keys(lifeCycles);
        const lifeCycleCounts = lifeCycleLabels.map((label) => lifeCycles[`${label}`].counts);
        this.lifeCycleTotal = this.prettyNumber(lifeCycleCounts.reduce((a,b) => a + b, 0));
        this.drawChartModels(lifeCycleLabels, lifeCycleCounts);
      }).catch(e => {
        this.displayError(e);
      });
    },

    drawChartModels(lifeCycleLabels, lifeCycleCounts) {
      const data = {
        datasets: [{
          data: lifeCycleCounts,
          backgroundColor: [
            '#18c266',
            '#f61920',
            '#4dc9f6',
            '#f67019',
            '#f6c619',
            '#19f6b7',
            '#36302e',
            '#922eb4',
            '#f6027f',
          ],
          label: 'Models'
        }],
        labels: lifeCycleLabels
      };

      new Chart(this.$refs.chartModels, {
        maintainAspectRatio: true,
        type: 'doughnut',
        data: data,
        options: {
          cutoutPercentage: 70,
          responsive: true,
          maintainAspectRatio: true,
          hover: {
            mode: 'index'
          },
          legend: {
            display: true,
            position: 'bottom',
          },
        }
      });
    },

    prettyNumber(number) {
      if(number < 1000) {
        return number;
      }
      else if(number > 999 && number < 1000000) {
        return parseFloat(number / 1000).toFixed(1) + 'K';
      }      
      else if(number > 1000000) {
        return parseFloat(number / 1000000).toFixed(1) + 'M';
      }
    },

    _chartColor(label, opacity) {
      switch(label) {
        case 'Auto-Filled':
          return `rgba(0,157,255, ${opacity || 1})`;
        case 'Auto-Corrected':
          return `rgba(136, 208, 255, ${opacity || 1})`;
        default:
          return `rgba(141, 141, 141, ${opacity || 1})`;
      }
    }
  },
}
